import { DashboardScreen } from '@/dashboard/DashboardScreen'

export function App() {
  return <DashboardScreen />
}
